import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DateRange } from '../../models/date-range';
import { ONLY_DATE } from '../../constants/date-formats';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
  standalone: false,
})
export class InputComponent implements OnInit, OnDestroy {
  @Input() control?: FormControl;
  @Input() label?: string;
  @Input() placeholder: string = '';
  @Input() type: 'text' | 'text-area' | 'password' | 'date' | 'date-range' =
    'text';
  @Input() readonly?: boolean;
  @Input() testId: string = '';
  @Input() showRequiredStar = true;
  @Input() textAreaHeight = 140;
  @Input() minDate?: Date;
  @Input() maxDate?: Date;

  rangeValue: DateRange = {};
  ONLY_DATE = ONLY_DATE;
  dateRangeOnChangeSubscription?: Subscription;

  ngOnInit(): void {
    if (this.type == 'date-range' && this.control) {
      this.dateRangeOnChangeSubscription = this.control.valueChanges.subscribe(() => {
        const startDate = this.control?.value.start;
        const endDate = this.control?.value.end;

        if (startDate) this.rangeValue.start = startDate;
        if (endDate) this.rangeValue.end = endDate;
      })
    }
  }

  ngOnDestroy(): void {
    this.dateRangeOnChangeSubscription?.unsubscribe();
  }

  get controlIsRequired(): boolean {
    return !!this.control?.hasValidator(Validators.required);
  }

  setStartRange(date: Date) {
    this.rangeValue.start = date;
    this.setRange();
  }

  setEndRange(date: Date) {
    this.rangeValue.end = date;
    this.setRange();
  }

  setRange() {
    this.control?.patchValue({
      start: this.rangeValue.start || null,
      end: this.rangeValue.end || null,
    });
  }
}
